import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { ConfigServerService, CustomHttp } from '../../../core';
import { ClienteAnaliseMercado } from '../cliente-analise-mercado';

@Injectable({
    providedIn: 'root'
})
export class ClienteAnaliseMercadoHttpService {
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/clienteanalisemercado`;
    }

    /** Carrega a análise de mercado através do cliente e ano informados */
    load(idCliente: number, ano: number): Observable<ClienteAnaliseMercado> {
        // Params
        const params = new HttpParams()
                            .append('idCliente', idCliente ? idCliente.toString() : null)
                            .append('ano', ano ? ano.toString() : null);

        return this.customHttp.get<ClienteAnaliseMercado>(`${this.pathApi}/load`, {params});
    }
}
